/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CompanyPhysician = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        companyId: {
    type: 'number',
    isRequired: true,
},
        employeeId: {
    type: 'number',
},
        name: {
    type: 'number',
    isRequired: true,
},
    },
};